import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  AbortController21osa5gzjz756 as AbortController,
  requireNodeFetch19juc7kebtu9r as requireNodeFetch,
  asByteArray2l3hscb95qi13 as asByteArray,
  readChunk37iql29cqo40z as readChunk,
} from './Js.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_isNodeu9kqlebvup92 as get_isNode } from '../../internal/is-node.mjs';
import { awaitopqeg9l1dqx0 as await_0 } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Promise.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Builder1mo34du82b3c6 as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/Http.mjs';
import { ApolloNetworkException3denf70pfh242 as ApolloNetworkException } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  intercepted2ogpsikxxj4u0 as intercepted,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  disposehycj9shx8d5q as dispose,
  HttpEngine345320iy1heif as HttpEngine,
} from './HttpEngine.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../../okio-parent-okio/okio/Buffer.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import {
  Companion_instance25ullnynvxd0w as Companion_instance,
  _Result___init__impl__xyqfz83a5421h46yeyh as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function DefaultHttpEngine(timeoutMillis) {
  timeoutMillis = timeoutMillis === VOID ? 60000n : timeoutMillis;
  return JsHttpEngine().a6d(timeoutMillis);
}
function *_generator_execute__d6syw1($this, request, $completion) {
  var abortController = AbortController();
  var connectTimeoutId = setTimeout(() => {
    abortController.abort();
    return Unit_instance;
  }, $this.x6c_1);
  var fetchOptions = toFetchOptions(request, abortController.signal);
  var tmp;
  if (get_isNode()) {
    tmp = $this.z6c_1(request.s49_1, fetchOptions);
  } else {
    tmp = fetch(request.s49_1, fetchOptions);
  }
  var responsePromise = tmp;
  var tmp_0;
  try {
    var tmp_1 = await_0(responsePromise, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var response = tmp_1;
    clearTimeout(connectTimeoutId);
    var tmp_2;
    if (get_isNode()) {
      var tmp_3 = readBodyNode(response.body, $this.y6c_1, abortController, $completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
      tmp_2 = tmp_3;
    } else {
      var tmp_4 = readBodyBrowser(response.body, $this.y6c_1, abortController, $completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      tmp_2 = tmp_4;
    }
    var responseBodySource = tmp_2;
    // Inline function 'kotlin.apply' call
    var this_0 = (new (Builder())(response.status)).l49(responseBodySource);
    var $this$apply = this_0;
    // Inline function 'kotlin.js.asDynamic' call
    response.headers.forEach((value, key) => $this$apply.v48(key, value));
    tmp_0 = this_0.n37();
  } catch ($p) {
    var tmp_5;
    if ($p instanceof Error) {
      var t = $p;
      var tmp_6;
      if (t instanceof CancellationException()) {
        abortController.abort();
        throw t;
      } else {
        throw ApolloNetworkException().q47('Failed to execute GraphQL http network request', t);
      }
    } else {
      throw $p;
    }
  }
  return tmp_0;
}
var JsHttpEngineClass;
function JsHttpEngine() {
  if (JsHttpEngineClass === VOID) {
    class $ {
      static b6d(connectTimeoutMillis, readTimeoutMillis) {
        var $this = createThis(this);
        $this.x6c_1 = connectTimeoutMillis;
        $this.y6c_1 = readTimeoutMillis;
        $this.z6c_1 = get_isNode() ? requireNodeFetch() : null;
        return $this;
      }
      static a6d(timeoutMillis) {
        return this.b6d(timeoutMillis, timeoutMillis);
      }
      r67(request, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_execute__d6syw1.bind(VOID, this, request), $completion);
      }
      q6() {
      }
    }
    protoOf($).vz = dispose;
    initMetadataForClass($, 'JsHttpEngine', VOID, VOID, [HttpEngine()], [1]);
    JsHttpEngineClass = $;
  }
  return JsHttpEngineClass;
}
function toFetchOptions(_this__u8e3s4, abortSignal) {
  var tmp;
  switch (_this__u8e3s4.r49_1.b2_1) {
    case 0:
      tmp = 'GET';
      break;
    case 1:
      tmp = 'POST';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var method = tmp;
  var headers = {};
  var _iterator__ex2g4s = _this__u8e3s4.t49_1.u1();
  while (_iterator__ex2g4s.v1()) {
    var header = _iterator__ex2g4s.w1();
    headers[header.f49_1] = header.g49_1;
  }
  var tmp1_safe_receiver = _this__u8e3s4.u49_1;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    headers['Content-Type'] = tmp1_safe_receiver.t47();
    // Inline function 'kotlin.takeIf' call
    var this_0 = tmp1_safe_receiver.u47();
    var tmp_1;
    if (this_0 >= 0n) {
      tmp_1 = this_0;
    } else {
      tmp_1 = null;
    }
    var tmp0_safe_receiver = tmp_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      headers['Content-Length'] = tmp0_safe_receiver.toString();
    }
    var bodyBuffer = new (Buffer())();
    tmp1_safe_receiver.w47(bodyBuffer);
    tmp_0 = bodyBuffer.v3y();
  }
  var bodyBytes = tmp_0;
  // Inline function 'com.apollographql.apollo.network.http.dynamicObject' call
  var init = ($this$dynamicObject) => {
    $this$dynamicObject.signal = abortSignal;
    $this$dynamicObject.method = method;
    $this$dynamicObject.headers = headers;
    var tmp;
    if (!(bodyBytes == null)) {
      tmp = $this$dynamicObject.body = bodyBytes;
    }
    return Unit_instance;
  };
  var js = {};
  init(js);
  return js;
}
function readBodyNode(body, readTimeoutMillis, abortController, $completion) {
  var readTimeoutId = {_v: setTimeout(() => {
    abortController.abort();
    return Unit_instance;
  }, readTimeoutMillis)};
  var bufferedSource = new (Buffer())();
  var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
  cancellable.c11();
  var continuation = cancellable;
  body.on('data', (chunk) => {
    clearTimeout(readTimeoutId._v);
    readTimeoutId._v = setTimeout(() => {
      abortController.abort();
      return Unit_instance;
    }, readTimeoutMillis);
    var chunkBytes = asByteArray(new Uint8Array(chunk));
    return bufferedSource.d3z(chunkBytes);
  });
  body.on('end', () => {
    var tmp0 = continuation;
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var value = bufferedSource;
    var tmp$ret$0 = _Result___init__impl__xyqfz8(value);
    tmp0.tc(tmp$ret$0);
    return Unit_instance;
  });
  body.on('error', (error) => {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    var this_0 = continuation;
    // Inline function 'kotlin.Companion.failure' call
    var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(error));
    this_0.tc(tmp$ret$2);
    return Unit_instance;
  });
  return cancellable.my();
}
function *_generator_readBodyBrowser__f701ok(body, readTimeoutMillis, abortController, $completion) {
  var readTimeoutId = setTimeout(() => {
    abortController.abort();
    return Unit_instance;
  }, readTimeoutMillis);
  var bufferedSource = new (Buffer())();
  var tmp;
  if (body == null) {
    return new (Buffer())();
  } else {
    tmp = body;
  }
  var stream = tmp;
  var reader = stream.getReader();
  $l$loop: while (true) {
    try {
      var tmp_0 = readChunk(reader, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      var chunk = tmp_0;
      clearTimeout(readTimeoutId);
      readTimeoutId = setTimeout(() => {
        abortController.abort();
        return Unit_instance;
      }, readTimeoutMillis);
      if (chunk == null) {
        break $l$loop;
      }
      bufferedSource.d3z(asByteArray(chunk));
    } catch ($p) {
      if ($p instanceof Error) {
        var cause = $p;
        reader.cancel(cause);
        throw cause;
      } else {
        throw $p;
      }
    }
  }
  return bufferedSource;
}
function readBodyBrowser(body, readTimeoutMillis, abortController, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBodyBrowser__f701ok.bind(VOID, body, readTimeoutMillis, abortController), $completion);
}
//region block: exports
export {
  DefaultHttpEngine as DefaultHttpEngine26xguluicr03l,
};
//endregion

//# sourceMappingURL=DefaultHttpEngine.js.mjs.map
